<template>
  <div class="interest flex">
    <div
      v-for="(interest, i) in $props.interests"
      :key="`interest-${i}`"
      class="interest-container flex"
    >
      <div v-if="interest.name" class="interest-container-name text-center">
        <h2>{{ interest.name }}</h2>
      </div>
      <div class="interest-container-data flex">
        <div v-if="interest.image || interest.icon" class="interest-container-data-image flex">
          <div
            :class="[
              'interest-container-data-image-container flex',
              { [interest.backgroundColor]: interest.backgroundColor }
            ]"
          >
            <img
              v-if="interest.image"
              :src="interest.image"
              :alt="interest.name"
              class="interest-container-data-image-container-tag"
            />
            <font-awesome-icon
              v-else-if="interest.icon"
              class="interest-container-data-image-container-tag"
              :icon="interest.icon"
              size="5x"
            />
          </div>
        </div>
        <div class="interest-container-data-description text-justify text-sm-left">
          <div v-if="interest.description" class="interest-container-data-description-text">
            <h3 class="interest-container-data-description-text-tag">{{ interest.description }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Interest",
  props: {
    /*
     * @property - interests
     * Array of interests. Defines all content inside this component
     * $interest[i].name
     * $interest[i].image
     * $interest[i].backgroundColor
     * $interest[i].description
     */
    interests: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.interest {
  flex-wrap: wrap;

  &-container {
    border-top: 0.0625rem solid $main-green;
    flex: 1 0 100%;
    flex-wrap: inherit;
    margin-bottom: 4rem;

    &:last-of-type {
      margin-bottom: 0rem;
    }

    &-name {
      margin-top: 2rem;
      padding: 0 0.5rem;
      width: 100%;
    }

    &-data {
      flex-wrap: inherit;
      padding: 0 1rem;
      width: 100%;

      &-image {
        width: 100%;

        @include breakpoint($medium) {
          flex: 0 0;
        }

        &-container {
          @include boxShadow(0.25, true, false);
          background-color: $white-raw;
          border: 0.0625rem solid $main-blue;
          border-radius: 0.45rem;
          color: $main-blue;
          height: 6.5rem;
          margin-right: auto;
          margin-left: auto;
          overflow: hidden;
          width: 6.5rem;

          &.black {
            background-color: $dark-gray;
            border: 0.0625rem solid $main-green;
            color: $main-green;
          }

          &-tag {
            margin: auto;
            max-height: 95%;
            max-width: 95%;
          }
        }
      }

      &-description {
        width: 100%;

        @include breakpoint($medium) {
          flex: 1 0;
          max-width: 100%;
          padding-left: 1rem;
        }

        &-text {
          width: 100%;

          &-tag {
            display: inline-block;
            margin: 0.75rem 0 0.25rem 0;

            @include breakpoint($medium) {
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
